// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--g-iuT","appear":"styles-module--appear--2JSnS","text":"styles-module--text--1FG8V","icon":"styles-module--icon--2RQ_r"};